import { Ability } from '@casl/ability'
import { initialAbility } from './config'

// Create a function to get abilities dynamically
const getAbilities = () => {
  try {
    // Read ability from localStorage
    // * Handles auto fetching previous abilities if already logged in user
    // ? You can update this if you store user abilities to more secure place
    // ! Anyone can update localStorage so be careful and please update this
    const userData = JSON.parse(localStorage.getItem('userData'))
    // console.log('userData: ', userData)
    const existingAbility = userData ? userData.abilities : null
    // console.log('abilities: ', existingAbility)
    
    return existingAbility || initialAbility
  } catch (error) {
    // console.error('Error reading abilities from localStorage:', error)
    return initialAbility
  }
}

// Create ability instance with initial abilities
const ability = new Ability(getAbilities())
// console.log('Ability instance created with initial abilities:', getAbilities())

// Export a function to update abilities when user logs in
export const updateAbilities = (newAbilities) => {
  // console.log('updateAbilities function called with:', newAbilities)
  ability.update(newAbilities)
  // console.log('Abilities updated successfully')
  // console.log('Current ability rules:', ability.rules)
}

// Export the ability instance
export default ability